var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['chart-change-indicator', _vm.colorClass]},[(isFinite(_vm.change))?_c('span',[_vm._v(_vm._s(_vm.sign)+_vm._s(_vm.formattedValue)+"%")]):_c('span',[_vm._v("0%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }